import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      padding: spacing.m,
      backgroundColor: theme.modal.background,
      borderRadius: constants.radius.card,
      width: "90vw",
      maxWidth: 480,
    },
    item: {
      marginBottom: spacing.m,
    },
  };

  return styles;
};
